import { createContext, useContext } from "react";
import type { PublicRelease } from "../api/types";
import type { CatalogFilters } from "./catalog-filters";

export type CatalogContextValue = {
  filters: CatalogFilters;
  years: number[];
  draftQuery: string;
  items: PublicRelease[];
  nextCursor: string | null;
  loading: boolean;
  loadingMore: boolean;
  error: string | null;
  fingerprint: string;
  loadedFingerprint: string | null;
  scrollTop: number;
  setDraftQuery: (value: string) => void;
  commitQuery: (value?: string) => void;
  setYear: (year: string) => void;
  setSort: (sort: CatalogFilters["sort"]) => void;
  setRareOnly: (rareOnly: boolean) => void;
  applyFilters: (filters: CatalogFilters) => void;
  resetFilters: () => void;
  ensureResults: () => Promise<void>;
  loadMore: () => Promise<void>;
  setScrollTop: (value: number) => void;
  patchRelease: (release: PublicRelease) => void;
};

export const CatalogContext = createContext<CatalogContextValue | null>(null);

export function useCatalog(): CatalogContextValue {
  const value = useContext(CatalogContext);
  if (!value) {
    throw new Error("useCatalog must be used within CatalogProvider");
  }
  return value;
}
